import React from "react";
import OrderField from "../shared/order_field";
import SpinLoading from "../../../../shared/spin_loading";

const OrderPrice = ({ price, priceTravella, priceSystem }) => {
  return (
    <OrderField
      title={I18n.t("js.order.fields.price")}
      overrideClass={"order-form__block order-form__block--total"}
    >
      <div className="order-form__block-content row">
        <div className="total-price col-md-5 col-lg-6">
          {price ? (
            <span className="price">
              <span className="result-price">
                {price?.toLocaleString("cs")}
              </span>
              <span className="unit"> {I18n.t("js.czk")}</span>
            </span>
          ) : (
            <SpinLoading show={!price} />
          )}
          {priceTravella && (
            <span className="price">
              <span className="result-price">
                {priceTravella?.toLocaleString("cs")}
              </span>
              <span className="unit"> {I18n.t("js.czk")} (Travella)</span>
            </span>
          )}
          {priceSystem && (
            <span className="price">
              <span className="result-price">
                {priceSystem?.toLocaleString("cs")}
              </span>
              <span className="unit"> {I18n.t("js.czk")} (Systém)</span>
            </span>
          )}
        </div>
        <div className="col-md-7 col-lg-6 next-step">
          <div className="data hidden"></div>
          {price && (
            <button type="submit" className="btn btn-secondary">
              {I18n.t("js.order.next_step")}
            </button>
          )}
        </div>
      </div>
    </OrderField>
  );
};

export default OrderPrice;
